import React, { ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import { endLiveMatchNotice } from '../../liveMatchSlice';
import './LiveMatchEndModal.scss';

const LiveMatchEndModal = (): ReactElement => {
  const dispatch = useDispatch();
  const isEndLiveMatch = useSelector(
    (state: AppState) => state.liveMatch.isEndLiveMatch,
  );
  const handleCloseEndLiveMatchModal = () => {
    dispatch(endLiveMatchNotice(false));
  };
  return (
    <Modal centered show={isEndLiveMatch}>
      <Modal.Body>
        <div className="root-end-live-match">
          <div className="end-live-match-title">コラボを終了しますか？</div>
          <div className="end-live-btn">終了する</div>
          <div
            className="end-live-btn-cancel"
            onClick={handleCloseEndLiveMatchModal}
          >
            キャンセル
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LiveMatchEndModal;
